import { Link } from 'react-router-dom';
import { useI18n } from '../contexts/I18nContext';
import { buildDashboardPath } from '../lib/routes';

export const DashboardBrand = ({ className = '' }) => {
  const { language, t } = useI18n();
  return (
    <Link className={`tns-dashboard-brand ${className}`} to={buildDashboardPath(language, 'profile')}
      aria-label={t('TNS Sentinel - صفحة المستخدم', 'TNS Sentinel - User Profile')}
      title={t('صفحة المستخدم', 'User Profile')}>
      <img src={`${process.env.PUBLIC_URL || ''}/branding/tns-sentinel-logo.png`} width="44" height="44" alt="" draggable={false} />
      <span className="tns-brand-wordmark" dir="ltr"><span>TNS</span><strong>SENTINEL</strong></span>
    </Link>
  );
};
